import { ONE_PAGE_STORE_TRACKER_TYPE } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

/**
 * @param {object} payload
 * @param {array} payload.cartItems - The items in cart.
 * @param {number} payload.subtotal - The subtotal of the cart.
 */
export const onTrackOrderCheckoutButtonClick = async (payload) => {
  const { cartItems, subtotal } = payload;
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: ONE_PAGE_STORE_TRACKER_TYPE.OrderCheckoutButtonClick,
    data: {
      scope: 'one_page_store',
    },
  });

  trackerService.fbInitiateCheckoutForCartLink(cartItems, subtotal);

  trackerService.track({
    type: trackerService.generalEventType.START_CHECKOUT,
    data: {
      items: cartItems,
      subtotal,
    },
  });
};
